import axios from 'axios';
import { ErrorService } from '@/services/error-service.js';
import i18n from '@/common/i18n/i18n.js';
import { setAxiosCsrfHeader } from '@/utils/requests.js';

const DEV_AUTH = process.env.NODE_ENV === 'development' ? true : false;

const AUTH = {
  username: process.env.VUE_APP_API_ADMIN_USERNAME,
  password: process.env.VUE_APP_API_ADMIN_PASSWORD
};

const path = require('path');
const DOMAIN = process.env.VUE_APP_DOMAIN;
const INDEXER_API_PATH = process.env.VUE_APP_INDEXER_API_PATH;

if (!DEV_AUTH) {
  axios.defaults.headers.common['X-CSRFToken'] = setAxiosCsrfHeader();
}

const indexersAPI = {
  async getIndexers() {
    const url = new URL(
      path.join(`${i18n.locale}${INDEXER_API_PATH}`, 'remote-api-indexes/'),
      DOMAIN
    );
    const response = await axios.get(url, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  },

  async getUsergroupIndexers(usergroupId) {
    const url = new URL(
      path.join(`${i18n.locale}${INDEXER_API_PATH}`, `remote-api-indexes/?usergroup_id=${usergroupId}`),
      DOMAIN
    );
    const response = await axios.get(url, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  },

  async getIndexersTypes() {
    const url = new URL(
      path.join(`${i18n.locale}${INDEXER_API_PATH}`, 'remote-api-index-types/'),
      DOMAIN
    );
    const response = await axios.get(url, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  },

  async getIndexer(id) {
    const url = new URL(
      path.join(`${i18n.locale}${INDEXER_API_PATH}`, `remote-api-indexes/${id}`),
      DOMAIN
    );
    const response = await axios.get(url, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  },

  async testIndexer(id) {
    const url = new URL(
      path.join(`${i18n.locale}${INDEXER_API_PATH}`, `remote-api-indexes/${id}/trial/`),
      DOMAIN
    );
    const response = await axios.get(url, { ...DEV_AUTH && { auth: AUTH } });
    if (response.status === 200) {
      return response.data;
    }
    return false;
  },

  async createIndexer(data) {
    try {
      const url = new URL(
        path.join(`${i18n.locale}${INDEXER_API_PATH}`, 'remote-api-indexes/'),
        DOMAIN
      );
      const response = await axios.post(url, data, { ...DEV_AUTH && { auth: AUTH } });
      if (response.status === 201) {
        ErrorService.onSuccess(
          response,
          i18n.messages[i18n.locale].indexers.messages.created.success
        );
        return response.data;
      }
    } catch {
      ErrorService.onError(
        false,
        i18n.messages[i18n.locale].indexers.messages.created.error
      );
      return false;
    }
  },

  async updateIndexer(id, data) {
    try {
      const url = new URL(
        path.join(`${i18n.locale}${INDEXER_API_PATH}`, `remote-api-indexes/${id}/`),
        DOMAIN
      );
      const response = await axios.put(url, data, { ...DEV_AUTH && { auth: AUTH } });
      if (response.status === 200) {
        ErrorService.onSuccess(
          response,
          i18n.messages[i18n.locale].indexers.messages.updated.success
        );
        return response.data;
      }
    } catch {
      ErrorService.onError(
        false,
        i18n.messages[i18n.locale].indexers.messages.updated.error
      );
      return false;
    }
  },

  async deleteIndexer(id) {
    try {
      const url = new URL(
        path.join(`${i18n.locale}${INDEXER_API_PATH}`, `remote-api-indexes/${id}/`),
        DOMAIN
      );
      const response = await axios.delete(url, { ...DEV_AUTH && { auth: AUTH } });
      if (response.status === 204) {
        ErrorService.onSuccess(
          response,
          i18n.messages[i18n.locale].indexers.messages.deleted.success
        );
        return true;
      }
    } catch {
      ErrorService.onError(
        false,
        i18n.messages[i18n.locale].indexers.messages.deleted.error
      );
      return false;
    }
  },
};

export default indexersAPI;